import api from 'api'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    unpayInvoice: build.mutation({
      query: ({ invoiceId }) => ({ url: `/api/v1/billing/invoice/${invoiceId}/unpay`, method: 'PUT' }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { useUnpayInvoiceMutation } = extendedApi
